require('./reportDialog.style.scss');

class ReportDialogController {
    constructor($filter, $document, $element, $window, notificationService, crudService, sharedPersistenceService) {
        this.$filter = $filter;
        this.$document = $document;
        this.$element = $element;
        this.$window = $window;
        this.notificationService = notificationService;
        this.modalTitle = this.$filter('translate')('tasks.report.dialog.title');
        this.TASKS_REST = sharedPersistenceService.getRestEndpoints().TASKS_REST;
        this.crudService = crudService;
    }

    $onInit() {
        this.actionButton = [
            {
                title: this.$filter('translate')('tasks.report.dialog.button'),
                action: () => this.copyToClipboard(),
            }
        ];
    }

    onOpen() {
        this.crudService.get(this.TASKS_REST + `/${this.selectedJob.uuid}/report`)
            .then(res => {
                let condition = '$Date:';
                this.jobsCtrl.checkForProperty(res.data, 'entities', condition);
                this.report = res.data.entities[0];
            });
    }

    onClose() {
    }

    copyToClipboard() {
        let selection = this.$window.getSelection();
        let reportContent = this.$document[0].getElementById('report-main-content');

        if (this.$document[0].body.createTextRange) {
            //IE
            reportContent.style['white-space'] = 'pre';
            let ieRange = this.$document[0].body.createTextRange();
            ieRange.moveToElementText(reportContent);
            ieRange.select();
            ieRange.execCommand("copy");
            reportContent.style['white-space'] = 'pre-line';
        } else if (selection && this.$document[0].createRange) {
            //Others
            let range = this.$document[0].createRange();
            range.selectNodeContents(reportContent);
            selection.removeAllRanges();
            selection.addRange(range);
        }
        try {
            let successful = this.$document[0].execCommand('copy');
            selection.removeAllRanges();
            this.notificationService.pop({
                type: successful ? 'success' : 'error',
                title: this.$filter('translate')(successful ? 'tasks.report.dialog.successCopy' : 'tasks.report.dialog.unsuccessCopy')
            });
        } catch (err) {
            this.notificationService.pop({
                type: 'error',
                title: this.$filter('translate')('tasks.report.dialog.errorCopy')
            });
        }
    }

}

ReportDialogController.$inject = ['$filter', '$document', '$element', '$window', 'notificationService', 'crudService', 'sharedPersistenceService'];

const reportDialogComponent = {
    controller: ReportDialogController,
    template: require('./reportDialog.template.html'),
    require: {
        jobsCtrl: '^^jobs'
    },
    bindings: {
        showModal: '=',
        selectedJob: '<',
    }
};

module.exports = reportDialogComponent;



// WEBPACK FOOTER //
// ./src/azurebackup/views/tasks/dialogs/reportDialog/reportDialog.component.js